module.exports = __webpack_public_path__ + "static/media/ill@3x.122034f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/ill@3x.png
// module id = 740
// module chunks = 0